import { trackKlaviyoEvent, identifyKlaviyoUser } from '../../helpers/klaviyo';
import { Accelerator } from "../../interfaces/accelerator";
import { Course } from "../../interfaces/course";
import { CurrentLesson } from "../../interfaces/currentLesson";
import { Lesson } from "../../interfaces/lesson";
import { PlayerProfileField } from "../dialogs/surveyModal/surveyQuestions";

export function totalTimeWatched(currentTime: number | undefined, accelerator: Accelerator, currentLesson: CurrentLesson) {
    const foundCourse = accelerator.courses.find(course => course.ID === currentLesson.courseID);
    const event = new CustomEvent('pgTotalTimeWatched', {
        detail: {
            programName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            duration: currentTime,
            videoName: currentLesson.name,
        }
    });
    window.dispatchEvent(event);
}

export function startedVideoEvent(currentTime: number | undefined, accelerator: Accelerator, currentLesson: CurrentLesson, vip: string, type?: string) {
    const foundCourse = accelerator.courses.find(course => course.ID === currentLesson.courseID);
    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") {
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }

    const event = new CustomEvent('pgLessonVideoPlay', {
        detail: {
            timestamp: currentTime,
            duration: currentLesson.video.duration,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            isProEdition: currentLesson.is_pro_edition,
            videoId: currentLesson.video.ID,
            videoName: currentLesson.name,
            lessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
            lessonId: currentLesson.ID,
            vip: vip,
            type: type
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Video Started', {
        ProgramID: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        LessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
        LessonID: currentLesson.ID,
        Status: 'Owned'
    });
}

export function startedDrillVideoEvent(currentTime: number | undefined, currentLesson: CurrentLesson) {
    const event = new CustomEvent('pgDrillVideoPlay', {
        detail: {
            timestamp: currentTime,
            duration: currentLesson.video.duration,
            videoId: currentLesson.video.ID,
            videoName: currentLesson.name,
            lessonName: currentLesson.name,
            lessonId: currentLesson.ID
        }
    });
    window.dispatchEvent(event);
}

export function pausedVideoEvent(currentTime: number | undefined, accelerator: Accelerator, currentLesson: CurrentLesson) {
    const foundCourse = accelerator.courses.find(course => course.ID === currentLesson.courseID);
    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") {
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }
    const event = new CustomEvent('pgLessonVideoPause', {
        detail: {
            timestamp: currentTime,
            duration: currentLesson.video.duration,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            videoId: currentLesson.video.ID,
            videoName: currentLesson.name,
            lessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
            lessonId: currentLesson.ID
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Video Paused', {
        ProgramID: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        LessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
        LessonID: currentLesson.ID,
        Status: 'Owned'
    });
}

export function pausedDrillVideoEvent(currentTime: number | undefined, currentLesson: CurrentLesson) {
    const event = new CustomEvent('pgDrillVideoPause', {
        detail: {
            timestamp: currentTime,
            duration: currentLesson.video.duration,
            videoId: currentLesson.video.ID,
            videoName: currentLesson.name,
            lessonName: currentLesson.name,
            lessonId: currentLesson.ID
        }
    });
    window.dispatchEvent(event);
}

export function lessonCompleteEvent(lesson: { lessonID: number, courseID: number, wasComplete: boolean }, lessonPlaylist: Lesson[], course: Course, accelerator: Accelerator) {
    const foundlesson = lessonPlaylist.find(index => index.ID === lesson.lessonID);
    const foundCourse = accelerator.courses.find(course => course.ID === lesson.courseID);
    const event = new CustomEvent('pgLessonComplete', {
        detail: {
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            videoId: foundlesson?.video.ID,
            videoName: foundlesson?.name,
            lessonName: foundlesson?.name,
            lessonId: foundlesson?.ID
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Video Marked Complete', {
        ProgramID: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        LessonName: foundlesson?.name,
        LessonID: foundlesson?.ID,
        Status: 'Owned'
    });
}

export function lessonVideoCompleteEvent(currentTime: number | undefined, accelerator: Accelerator, currentLesson: CurrentLesson, vip: string, type?: string) {
    const foundCourse = accelerator.courses.find(course => course.ID === currentLesson.courseID);
    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") {
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }
    const event = new CustomEvent('pgLessonVideoEnded', {
        detail: {
            timestamp: currentTime,
            duration: currentLesson.video.duration,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            videoId: currentLesson.video.ID,
            videoName: currentLesson.name,
            lessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
            lessonId: currentLesson.ID,
            vip: vip,
            type: type
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Video Completed', {
        ProgramID: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        LessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
        LessonID: currentLesson.ID,
        Status: 'Owned'
    });
}

export function drillCompleteEvent(lesson: { lessonID: number, courseID: number, wasComplete: boolean }, lessonPlaylist: Lesson[], course: Course, accelerator: Accelerator) {
    const foundlesson = lessonPlaylist.find(index => index.ID === lesson.lessonID);
    const event = new CustomEvent('pgDrillVideoEnded', {
        detail: {
            courseId: accelerator.ID,
            courseName: accelerator.name,
            videoId: foundlesson?.video.ID,
            videoName: foundlesson?.name,
            lessonName: foundlesson?.name,
            lessonId: foundlesson?.ID
        }
    });
    window.dispatchEvent(event);
}

export function favoriteVideoEvent(lesson: Lesson, course: Course, add: boolean, accelerator: Accelerator) {
    const event = new CustomEvent('pgLessonFavorite', {
        detail: {
            add: add,
            courseId: accelerator.isCourse ? accelerator.ID : course.ID,
            courseName: accelerator.isCourse ? accelerator.name : course.name,
            videoId: lesson.video.ID,
            videoName: lesson.name,
            lessonName: lesson.name,
            lessonId: lesson.ID
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Video Favorited', {
        ProgramID: accelerator.isCourse ? accelerator.ID : course.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : course.name,
        LessonName: lesson.name,
        LessonID: lesson.ID,
    });
}


export function videoAutoplayToggleEvent(status: string,lesson: Lesson,  accelerator: Accelerator, location: string) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgVideoAutoplayToggle', {
        detail: {
            status: status,
            programName : accelerator.isCourse ? accelerator.name : foundCourse?.name,
            location : location
        }
    });
    window.dispatchEvent(event);
}

export function replayLessonEvent(lesson: Lesson,  accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") { 
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }
    
    const event = new CustomEvent('pgReplayLessonEvent', {
        detail: {
            lessonName: trainingIntroName ? trainingIntroName : lesson.name,
            programName : accelerator.isCourse ? accelerator.name : foundCourse?.name,
        }
    });
    window.dispatchEvent(event);
}

export function scorecardAddEvent(statsIncluded:string,source:string = "Record & Track") {
    const event = new CustomEvent('pgScorecardAdd',{
        detail:{
            statsIncluded,
            source
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Scorecard Submitted', {
        StatsIncluded: statsIncluded,
        Source: source,
    });
}

export function drillScoreAddEvent(lesson: Lesson) {
    const event = new CustomEvent('pgDrillRecordSubmit', {
        detail: {
            videoId: lesson.video.ID,
            videoName: lesson.name,
            lessonName: lesson.name,
            lessonId: lesson.ID
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Challenge Score Submitted', {
        drill_name: lesson.name,
    });
}

export function pageViewEvent(pageName: string) {
    const event = new CustomEvent('pgScratchClubView', {
        detail: {
            Page: pageName
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Scratch Club Viewed', {});
}

export function trainingProgramViewed(lesson: Lesson, accelerator: Accelerator, vip: string, type?: string) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") {
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }

    const event = new CustomEvent('pgLessonViewed', {
        detail: {
            lessonType: lesson.lesson_type,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            videoId: lesson.video.ID,
            videoName: lesson.name,
            lessonName: trainingIntroName ? trainingIntroName : lesson.name,
            lessonId: lesson.ID,
            vip: vip,
            type: type
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Program Viewed', {
        ProgramID: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        VideoName: lesson.name,
        LessonName: trainingIntroName ? trainingIntroName : lesson.name,
        LessonID: lesson.ID,
        VIPGolfSchoolPlaylist: vip,
    });
}

export function trainingCourseCompleted(lesson: Lesson, accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgtrainingCourseCompleted', {
        detail: {
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Course Completed', {
        ProgramName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
    });
}

export function trainingCourseAllVideosWatched(lesson: Lesson, accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgtrainingCourseAllVideosWatched', {
        detail: {
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Course All Videos Watched', {});
}

export function videoProgress(seconds: number) {
    const event = new CustomEvent('pgLessonVideoSecondChange', {
        detail: {
            seconds: seconds
        }
    });
    window.dispatchEvent(event);
}

export function viewProduct(source: string, type: string, sku: string, location?: string, courseName?: string) {
    const event = new CustomEvent('pgViewProductRecommendation', {
        detail: {
            source: source,
            type: type,
            sku: sku,
            courseName: courseName,
            location: location
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('View Product Recommendation', {
        Source: source,
        CTALocation: location,
    });
}

export function clickProduct(source: string, type: string, sku: string, courseID?: number, courseName?: string, location?: string) {
    const event = new CustomEvent('pgClickProductRecommendation', {
        detail: {
            source: source,
            type: type,
            sku: sku,
            courseId: courseID,
            courseName: courseName,
            location: location
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Click Product Recommendation', {
        Source: source,
        CTALocation: location,
    });
}


export function viewAcceleratorSurvey(accelerator: string, question: number[]) {
    const event = new CustomEvent('pgAcceleratorSurveyView', {
        detail: {
            Accelerator: accelerator,
            Question: question,
        }
    });
    window.dispatchEvent(event);
}

export function answerAcceleratorSurvey(accelerator: string, question: number, answer: string) {
    const event = new CustomEvent('pgAcceleratorSurveyAnswer', {
        detail: {
            accelerator: accelerator,
            question: question,
            answer: answer,

        }
    });
    window.dispatchEvent(event);
}

export function clickVipProductRecommendation(location: string, lesson: Lesson, accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgClickVipProductRecommendation', {
        detail: {
            lessonType: lesson.lesson_type,
            ctaLocation: location,
            recommendationType: "Golf School",
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            lessonName: lesson.name,
            lessonId: lesson.ID,
            videoId: lesson.video.ID,
            videoName: lesson.name,

        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Click Product Recommendation', {
        CTALocation: location,
    });
}

export function clickUpNextProductRecommendation(location: string, lesson: Lesson, accelerator: Accelerator, SKU: string) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgClickNextUpProductRecommendation', {
        detail: {
            lessonType: lesson.lesson_type,
            ctaLocation: location,
            recommendationType: "Finished Course",
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            sku: SKU
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Click Product Recommendation', {
        CTALocation: location,
    });
}

export function clickFooterProductRecommendation(lessonID: string, lessonName: string, lessonType: string) {
    const event = new CustomEvent('pgClickFooterProductRecommendation', {
        detail: {
            lessonType: lessonType,
            ctaLocation: "Footer",
            recommendationType: "Carousel",
            courseId: lessonID,
            courseName: lessonName
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Click Product Recommendation', {
        CTALocation: "Footer",
    });
}

export function clickFinishedtProductRecommendation(sku: string, accelerator: Accelerator, lesson: Lesson, location: string) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    const event = new CustomEvent('pgClickFinishedProductRecommendation', {
        detail: {
            sku: sku,
            ctaLocation: location,
            recommendationType: "Finished Course",
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Click Product Recommendation', {
        CTALocation: "Footer",
    });
}

export function viewedDidYouKnowMessage(location: string, type: string) {
    const event = new CustomEvent('pgViewDidYouKnow', {
        detail: {
            location: location,
            type: type,
        }
    });
    window.dispatchEvent(event);
}

export function clickCourseButton(version: string, type: string, status: string, programName: string, locationValue: string, hasAccess?: boolean) {
    let categoryName = '';
    if (type.indexOf('Training Programs') != -1) {
        categoryName = 'User’s Training Programs';
    } else if (type.indexOf('Popular') != -1) {
        categoryName = 'Popular';
    } else {
        categoryName = type;
    }

    let scName = '';
    if (type.indexOf('Accelerators') != -1) {
        scName = 'Accelerator Name';
    } else if (type.indexOf('Drills') != -1) {
        scName = 'Drill Name';
    }

    const detail: any = {
        Version: version,
        'Category Name': categoryName,
        Status: status,
        Location: locationValue
    };

    detail[scName !== '' ? scName : 'Program Name'] = programName;


    if (window.popularCoursesPriority) {
        detail['Split'] = 'WE546';
    }
    if (window.netflixCourseButtonsSplit) {
        detail['Split'] = detail['Split'] ? detail['Split'] + ',WE522' : 'WE522';
    }

    if (!window.pgUser?.products?.some((product: string) => product === '125' || product === '124')
        && window.championsPassModalLockedABTest
        && hasAccess) {
        detail['Split'] = detail['Split'] ? detail['Split'] + ',WE734' : 'WE734';
    }
    const event = new CustomEvent('pgClickCourseButton', {
        detail: detail
    });
    window.dispatchEvent(event);
};




export function viewedDidYouKnowBanner(location: string, type: string) {
    const event = new CustomEvent('pgViewDidYouKnowBanner', {
        detail: {
            location: location,
            type: type,
        }
    });
    window.dispatchEvent(event);
}

export function clickDidYouKnowBanner(accelerator: Accelerator, lesson: Lesson, location: string, type: string) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    const event = new CustomEvent('pgClickDidYouKnowBanner', {
        detail: {
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            type: type,
            location: location
        }
    });
    window.dispatchEvent(event);
}

export function clickedVipGolfSchool(accelerator: Accelerator, lesson: Lesson, location: string) {

    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    const event = new CustomEvent('pgClickedVipGolfSchool', {
        detail: {
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            courseCoach: accelerator.coach,
            location: location
        }
    });
    window.dispatchEvent(event);
}

export function clickedVipGolfSchoolAtVideoEnd(accelerator: Accelerator, currentLesson: Lesson) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === currentLesson.ID));

    let trainingIntroName = "";
    if (foundCourse && foundCourse.name === "") {
        trainingIntroName = foundCourse.lessons[0].url.split("/courses/")[1].replace(/-/g, ' ').replace(/\/$/, '').replace(/\b\w/g, (char) => char.toUpperCase()) + " Introduction";
    }

    const event = new CustomEvent('pgClickedVipGolfSchool', {
        detail: {
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            courseCoach: accelerator.coach,
            lessonName: trainingIntroName ? trainingIntroName : currentLesson.name,
            videoName: currentLesson.name,
            type: "End of Video"
        }
    });
    window.dispatchEvent(event);
}
export function viewedVipGolfSchool(location: string) {
    const event = new CustomEvent('pgViewedVipGolfSchool', {
        detail: {
            location: location,
        }
    });
    window.dispatchEvent(event);
}
export function clickedVipButtonGolfSchool(type: string, lesson: Lesson, accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));
    const event = new CustomEvent('pgClickedVipGolfSchool', {
        detail: {
            type: type,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            courseCoach: accelerator.coach,
            lessonName: lesson.name,
            lessonId: lesson.ID,
            videoId: lesson.video.ID,
            videoName: lesson.name,
        }
    });
    window.dispatchEvent(event);
}

export function clickVipLearnMore(type: string, lesson: Lesson, accelerator: Accelerator) {
    const foundCourse = accelerator.courses.find(course => course.lessons.find(cLesson => cLesson.ID === lesson.ID));

    const event = new CustomEvent('pgClickedVipGolfSchool', {
        detail: {
            type: type,
            courseId: accelerator.isCourse ? accelerator.ID : foundCourse?.ID,
            courseName: accelerator.isCourse ? accelerator.name : foundCourse?.name,
            courseCoach: accelerator.coach,
        }
    });
    window.dispatchEvent(event);
}

export function netflixTrainingProgramViewed() {

    const event = new CustomEvent('pgNetflixLessonViewed', {
        detail: {
            version: "Netflix"
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Training Programs List Viewed', {});
}

export function netflixFilterCleared(allFilters: Record<string, string[]>, filter?: string, fValue?: string) {

    const event = new CustomEvent('pgCourseFilterRemove', {
        detail: {
            allFilters: allFilters,
            filter: filter,
            value: fValue
        }
    });
    window.dispatchEvent(event);
    const activeFilters = Object.fromEntries(
        Object.entries(allFilters).filter(([, v]) => v.length > 0)
    );
    trackKlaviyoEvent('Training Programs List Filter Cleared', { ...activeFilters });
}

export function netflixFilterChosen(filter: string, fValue: string, allFilters: Record<string, string[]>) {

    const event = new CustomEvent('pgCourseFilterAdd', {
        detail: {
            filter: filter,
            value: fValue,
            allFilters: allFilters
        }
    });
    window.dispatchEvent(event);
    const activeFilters = Object.fromEntries(
        Object.entries(allFilters).filter(([, v]) => v.length > 0)
    );
    trackKlaviyoEvent('Training Programs List Filtered', { ...activeFilters });
}

export function clickedLockedCourse(type: string, location: string, name: string) {

    const event = new CustomEvent('pgClickedLockedCourse', {
        detail: {
            type: type,
            location: location,
            name: name
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Focus_Matched_Course_Unlock_Clicked', {
        source: location,
    });
}

export function viewChampionPassModal(source: string, type: string, sku: string, location?: string, courseName?: string, split?: any) {
    const event = new CustomEvent('pgViewedChampionsPassModal', {
        detail: {
            split: split,
            type: type,
            source: source,
            sku: sku,
            location: location,
            courseName: courseName
        }
    });
    window.dispatchEvent(event);
}

export function clickedChampionPassModal() {
    const detail: any = {};

    if (window.championsPassTrialPricing) {
        detail.Split = 'WE603';
    }

    const event = new CustomEvent('pgClickedChampionsPassModalCTA', {
        detail: detail
    });
    window.dispatchEvent(event);
}

export type SurveyLocation = 'onboarding' | 'guided-journey';

export function onboardingSurveyAnswered(
    playerProfileField: PlayerProfileField,
    value: string,
    location: SurveyLocation
): void {
    const event = new CustomEvent('pgOnboardingSurveyAnswered', {
        detail: {
            playerProfileField,
            value,
            location,
        },
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Onboarding Answered', {
        Answer: value,
        Page: location,
    });
}

export function onboardingSurveyBackArrowUsed(
    step: string,
    location: string
): void {
    const timestamp = new Date().toISOString();
    const event = new CustomEvent("pgOnboardingSurveyBackArrowUsed", {
        detail: { step, location, timestamp }
    });
    window.dispatchEvent(event);
}

export function onboardingSurveyClosed(
    location: SurveyLocation
): void {
    const event = new CustomEvent('pgOnboardingSurveyClosed', {
        detail: {
            location,
        },
    });
    window.dispatchEvent(event);
}

export function onboardingSurveyCompleted(
    location: SurveyLocation
): void {
    const event = new CustomEvent('pgOnboardingSurveyCompleted', {
        detail: {
            location,
        },
    });
    window.dispatchEvent(event);
}

export function onboardingSurveyViewed(
    location: SurveyLocation
): void {
    const event = new CustomEvent('pgOnboardingSurveyViewed', {
        detail: {
            location,
        },
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Onboarding Viewed', {
        Page: location,
    });
}

export function guidedJourneySurveyViewed(programName: string): void {
    const event = new CustomEvent('pgGuidedJourneySurveyViewed', {
        detail: {
            programName,
        },
    });
    window.dispatchEvent(event);
}


export function pgGuidedJourneySurveyViewed(detail: any): void {
    const event = new CustomEvent('pgGuidedJourneySurveyViewed', {
        detail: detail,
    });
    window.dispatchEvent(event);
}

export function guidedJourneySurveySkipped(programName: string): void {
    const event = new CustomEvent('pgGuidedJourneySurveySkipped', {
        detail: {
            programName,
        },
    });
    window.dispatchEvent(event);
}

export function guidedJourneySurveyAnswered(
    programName: string,
    questionName: string,
    answer: string,
): void {
    const event = new CustomEvent('pgGuidedJourneySurveyAnswered', {
        detail: {
            programName,
            questionName,
            answer,
        },
    });
    window.dispatchEvent(event);
}

export function pgGuidedJourneySurveyAnswered(detail: any): void {
    const event = new CustomEvent('pgGuidedJourneySurveyAnswered', {
        detail: detail,
    });
    window.dispatchEvent(event);
}

export function pgApiError(body: any) {
    const event = new CustomEvent('pgApiError', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgAuthCreateAccount(type: string = "Email", email?: string): void {
    const event = new CustomEvent('pgUserCreateAccount', {
        detail: { type }
    });
    window.dispatchEvent(event);
    identifyKlaviyoUser(email);
    trackKlaviyoEvent('App Account Created', {
        type: type,
    });
}

export function pgAuthPasswordReset(type?: string): void {
    const event = new CustomEvent('pgUserPasswordReset', {
        detail: type ? { type } : {}
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Password Reset', {Page: 'Web Page Login'});
}

export function pgAuthLogin(): void {
    const event = new CustomEvent('pgUserLogin', {
        detail: {}
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Login');
}

export function clickedChatWithUs(location: string) {
    const event = new CustomEvent('pgClickedChatWithUs', {
        detail: {
            Location: location
        }
    });
    window.dispatchEvent(event);
}

export function clickedAccordionMenu(location: string, primaryCategory: string, subCategory: string) {
    const event = new CustomEvent('pgClickedAccordionMenu', {
        detail: {
            Location: location,
            'Primary Category': primaryCategory,
            'Sub Category': subCategory
        }
    });
    window.dispatchEvent(event);
}
export function pgOrderHistory(body: any) {
    const event = new CustomEvent('pgOrderHistory', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function contactUsSearchCompleted(searchQuery: string): void {
    const event = new CustomEvent('pgContactUsSearchCompleted', {
        detail: {
            searchQuery,
        },
    });
    window.dispatchEvent(event);
}

export function pgVIPViewed(location: string) {
    const event = new CustomEvent('pgVIPViewed', {
        detail: {
            Page: location,
        }
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('VIP Coaching Viewed', {
        Page: location,
    });
}

export function pgVIPHelpSwing(body: any) {
    const event = new CustomEvent('pgVIPHelpSwing', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVIPOnboardingTab(body: any) {
    const event = new CustomEvent('pgVIPOnboardingTab', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVipCoachingSurvey(body: any) {
    const event = new CustomEvent('pgVipCoachingSurvey', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVIPNewMessage(body: any) {
    const event = new CustomEvent('pgVIPNewMessage', {
        detail: body
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('VIP Message Sent', {});
}

export function pgVIPVideoUpload(body: any) {
    const event = new CustomEvent('pgVIPVideoUpload', {
        detail: body
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('VIPCoach_VideoUpload_Completed', {});
}

export function pgVIPCoachSetFilter(body: any) {
    const event = new CustomEvent('pgVIPCoachSetFilter', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVIPCoachSearch() {
    const event = new CustomEvent('pgVIPCoachSearch', {
        detail: {}
    });
    window.dispatchEvent(event);
}

export function pgVIPCoachAssignToMe(body: any) {
    const event = new CustomEvent('pgVIPCoachAssignToMe', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVIPPlayedSwing(body: any) {
    const event = new CustomEvent('pgVIPPlayedSwing', {
        detail: body
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Played Swing Video', {});
}

export function pgVIPMaxFileSize(body: any) {
    const event = new CustomEvent('pgVIPMaxFileSize', {
        detail: body
    });
    window.dispatchEvent(event);
}

export function pgVIPCoachShowChat(body: any) {
    const event = new CustomEvent('pgVIPCoachShowChat', {
        detail: body
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('VIPCoach_CoachResponse_Viewed', {});
}

// Auth events
export function loginEvent(): void {
    window.dispatchEvent(new CustomEvent("pgUserLogin"));
    trackKlaviyoEvent('Login');
}

export function createAccountEvent(email?: string): void {
    window.dispatchEvent(new CustomEvent("pgUserCreateAccount"));
    identifyKlaviyoUser(email);
    trackKlaviyoEvent('App Account Created');
}

export function userPrefsTabEvent(tabId: string): void {
    const event = new CustomEvent('pgUserPrefsTab', {
        detail: {
            tabId,
        },
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('User Preferences Viewed', {
        Page: 'EditProfile',
    });
}
export function userPrefsUpdateEvent(preference: string[]): void {
    const event = new CustomEvent('pgUserPrefsUpdate', {
        detail: {
            Preference: preference,
        },
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('User Preference Updated', {});
}
export function userPasswordUpdateEvent(source: string = 'Profile'): void {
    const event = new CustomEvent('pgUserPasswordUpdate', {
        detail: {
            Source: source,
        },
    });
    window.dispatchEvent(event);
    trackKlaviyoEvent('Password Updated', {
        Page: "Profile",
    });
}